import { Box, Stack, Typography } from "@mui/material";

import { CompetitivenessBandBar } from "./CompetitivenessBandBar";
import { TIER_CONFIG } from "./tiers";
import { useIsMobile } from "../../../../hooks/useIsMobile";

import type { CompetitivenessTier } from "./tiers";

interface BookedPriceRevealTierProps {
  tier: CompetitivenessTier;
}

export function BookedPriceRevealTier(props: BookedPriceRevealTierProps) {
  const { tier } = props;
  const config = TIER_CONFIG[tier];
  const Icon = config.icon;
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor: "white",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "grey.300",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "4px",
          bgcolor: config.color,
        }}
      />

      <Stack
        spacing={1}
        sx={{ pl: isMobile ? 1.5 : 2.5, pr: isMobile ? 1.5 : 2, py: 1.5 }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
          flexWrap="wrap"
        >
          <Box
            sx={{
              p: 0.75,
              borderRadius: "50%",
              bgcolor: `${config.color}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon sx={{ fontSize: 20, color: config.color }} />
          </Box>

          <Box
            sx={{
              px: 1.25,
              py: 0.25,
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              border: "1px solid",
              bgcolor: `${config.color}10`,
              color: config.color,
              borderColor: `${config.color}30`,
            }}
          >
            {config.label}
          </Box>

          <Typography
            variant="body2"
            sx={{ color: "text.secondary", ml: "auto !important" }}
          >
            {config.range}
          </Typography>
        </Stack>

        <CompetitivenessBandBar tier={tier} />

        <Typography variant="body2" sx={{ color: "text.secondary", pl: 0.5 }}>
          {config.description}
        </Typography>
      </Stack>
    </Box>
  );
}
